<template>
  <div class="zm-popup-captcha">
    <p class="zm-popup-captcha__tips1 mgb-sm">
      {{t('popup-captcha.tips1')}}
    </p>
    <p class="zm-popup-captcha__tips2 mgb-md">
      {{t('popup-captcha.tips2')}}
    </p>
    <zm-captcha
      :type="type"
      :error-message="errorMessage"
      :routing-url="routingUrl"
      :is-hcaptcha="isHcaptcha"
      v-model="captcha"
      ref="captcha"
    ></zm-captcha>
    <zm-button
      type="primary"
      class="mgt-sm"
      @click="validate"
    >
      {{t('popup-captcha.validate')}}
    </zm-button>
  </div>
</template>

<script>
  import Locale from '../../mixins/locale';
  import '../../../i18n/popup-captcha';

  export default {
    name: 'PopupCaptcha',
    mixins: [Locale],
    data() {
      return {
        type: 'input',
        captcha: '',
        errorMessage: '',
        routingUrl: '',
        isHcaptcha: false
      };
    },
    methods: {
      validate() {
        this.$refs.captcha.validate((validate) => {
          if (validate) {
            this.errorMessage = '';
            this.$emit('validate', this.captcha);
          }
        });
      },
      refresh() {
        this.$refs.captcha.refresh();
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(popup-captcha) {
    margin-bottom: -24px;

    @include e(tips1) {
      color: $--color-text-primary;
      font-size: 16px;
    }

    @include e(tips2) {
      color: $--color-text-placeholder;
    }
  }
</style>
